import React from 'react'
import TopBar from '../Home/Mainhomeone/Topbar'
import Header from '../Globle/Header1'
import Navigation from '../Home/Mainhomeone/Navigation'
import Breadecrumb from '../Globle/Breadecrumb'
import WishList from '../MainCart/WishList'
import Footer1 from '../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadecrumb title='WishList' />
            <WishList />
            <Footer1 />

        </>
    )
}

export default Main
